export function formatTimeDetailed(time: number): string {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);
  const milliseconds = Math.floor((time % 1) * 100);
  
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${milliseconds.toString().padStart(2, '0')}`;
}

/**
 * Format timecode in broadcast HH:MM:SS:FF format.
 * @param frames - Total frame count
 * @param fps - Frames per second (default 25)
 */
export function formatTimecodeFromFrames(frames: number, fps = 25): string {
  const f = frames % fps;
  const totalSec = Math.floor(frames / fps);
  const s = totalSec % 60;
  const m = Math.floor(totalSec / 60) % 60;
  const h = Math.floor(totalSec / 3600);
  return [h, m, s, f].map((v) => String(v).padStart(2, "0")).join(":");
}

/**
 * Parse a timecode string "HH:MM:SS:FF" into total frames.
 */
export function parseTimecodeToFrames(tc: string, fps = 25): number {
  const parts = tc.split(":").map(Number);
  if (parts.length !== 4) return 0;
  const [h, m, s, f] = parts;
  return h * 3600 * fps + m * 60 * fps + s * fps + f;
}

export function formatTimeSimple(time: number): string {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export function formatTimeAgo(date: Date): string {
  const now = Date.now();
  const diffMs = now - date.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffSeconds < 60) return 'maintenant';
  if (diffMinutes < 60) return `${diffMinutes}m`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays < 30) return `${diffDays}j`;
  if (diffMonths < 12) return `${diffMonths}mo`;
  return `${diffYears}a`;
}
